import { finite } from './sessions/gait-total.js'

// A step lasts at least one day: a 0-day step never shows up on any day of the
// program. The upper bound is the API's own limit (day_count is a tinyint).
export const STEP_DAY_COUNT_MIN = 1
export const STEP_DAY_COUNT_MAX = 200

// The whole number of days typed for a step, or null when it cannot be saved.
// The number input can hand back a number or a string ("5", "", "1.5").
export const parseStepDayCount = (value) => {
    if (typeof value !== 'number' && typeof value !== 'string') return null
    if (typeof value === 'string' && value.trim() === '') return null

    const count = Number(value)
    if (!Number.isInteger(count)) return null
    if (count < STEP_DAY_COUNT_MIN || count > STEP_DAY_COUNT_MAX) return null

    return count
}

// What a save on a step card changed: the step itself (days, description) or
// one of its gait rows (added, edited, removed). Both are sent the same way,
// but the confirmation must name what the rider touched.
export const STEP_SAVE_STEP = 'step'
export const STEP_SAVE_GAIT = 'gait'

// The i18n key of the toast confirming a saved step card. Only a gait row edit
// keeps the gait wording; anything else speaks of the step.
export const stepSavedMessageKey = (scope) =>
    scope === STEP_SAVE_GAIT ? 'protocol.protocol-step-updated' : 'protocol.step-updated'

// Whether a gait row differs from the copy taken when its edit was opened, so
// confirming a row left as it was sends no request. The duration can come back
// from the API as a string ("30") while the picker hands back a number. Without
// a copy the row is treated as changed, so a save is never lost.
export const gaitRowChanged = (before, after) => {
    if (!before) return true
    return before.gait !== after?.gait || finite(before.duration) !== finite(after?.duration)
}

// Segments of a step's gait bar: one per gait row, in the order the rows are
// ridden, each sized by its share of the step's total duration. Rows without a
// positive duration take no room.
export const gaitBarSegments = (gaits) => {
    const rows = (Array.isArray(gaits) ? gaits : [])
        .map((row) => ({ gait: row?.gait, duration: Number(row?.duration) }))
        .filter((row) => Number.isFinite(row.duration) && row.duration > 0)

    const total = rows.reduce((sum, row) => sum + row.duration, 0)
    if (!total) return []

    return rows.map((row) => ({ ...row, percent: (row.duration / total) * 100 }))
}
